var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("manual_action.dialog.title"),
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        width: "520px"
      },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-position": "top" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("manual_action.dialog.channel") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("manual_action.dialog.channel")
                  },
                  model: {
                    value: _vm.form.channel,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "channel", $$v)
                    },
                    expression: "form.channel"
                  }
                },
                _vm._l(_vm.channels, function(channel) {
                  return _c("el-option", {
                    key: channel,
                    attrs: { label: channel, value: channel }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("manual_action.dialog.reason") } },
            [
              _c("el-input", {
                attrs: {
                  width: "100%",
                  type: "textarea",
                  rows: 4,
                  placeholder: _vm.$t("manual_action.dialog.reason")
                },
                model: {
                  value: _vm.form.reason,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "reason", $$v)
                  },
                  expression: "form.reason"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("manual_action.dialog.date") } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "date",
                  placeholder: _vm.$t("manual_action.dialog.pick_a_day")
                },
                model: {
                  value: _vm.form.start_time,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "start_time", $$v)
                  },
                  expression: "form.start_time"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("manual_action.dialog.assignee") } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    placeholder: _vm.$t("manual_action.dialog.assignee")
                  },
                  model: {
                    value: _vm.form.assignee,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "assignee", $$v)
                    },
                    expression: "form.assignee"
                  }
                },
                [
                  _c("el-option", {
                    key: "unassigned",
                    attrs: { label: "Niemand", value: "unassigned" }
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.$store.state.risolto.participantUsers, function(
                    user
                  ) {
                    return _c("el-option", {
                      key: user.person_by_reference.reference,
                      attrs: {
                        label: user.person_by_reference.username,
                        value: user.person_by_reference.reference
                      }
                    })
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("shared.Cancel")))
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.loading, type: "primary" },
              on: { click: _vm.onSubmit }
            },
            [_vm._v(_vm._s(_vm.$t("shared.Confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }